<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({

  }),
  computed: {
    ...mapGetters(['sessionTimedOut'])
  },
  methods: {
    logout() {
      this.$router.push({ name: 'logout' }).catch(() => {})
    }
  }
}
</script>
<template>
  <v-dialog :value="sessionTimedOut" width="500" persistent>
    <v-card>
      <v-card-title class="justify-left">
        <h1 class="headline primary--text text--primary-2">
          {{ $t('global.session.timeout.header') }}
        </h1>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5 pb-1">
        <p class="pl-3">
        {{ $t('global.session.timeout.content') }}</p>
      </v-card-text>
      <v-divider class="py-1"></v-divider>
      <v-card-actions class="pr-3 pb-3">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          class="white--text text-capitalize"
          @click="logout">
          <span>{{$t('button.close') }}</span></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
